import React, { useState } from "react";
import Slider from "react-slick";
import { makeStyles } from "@material-ui/core/styles";
import { useOperation } from "../../Context/OperationContext";
import CardSlide from "../Card/cardSlide";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Grid from "@material-ui/core/Grid";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import style from "../../assets/jss/disal-main/components/Slide";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

function NextArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      className={className}
      style={{ display: "block" }}
      onClick={onClick}
    >
      <ArrowForwardIosIcon className="arrow-style" />
    </button>
  );
}

function PrevArrow(props) {
  const { className, onClick } = props;
  return (
    <button
      className={className}
      style={{ display: "block" }}
      onClick={onClick}
    >
      <ArrowBackIosIcon className="arrow-style" />
    </button>
  );
}

const useStyles = makeStyles(style);
const Slide = () => {
  const classes = useStyles();
  const { operationData } = useOperation();
  const [open, setOpen] = useState(false);

  const settings = {
    dots: true,
    infinite: operationData.arrayVehicle.length > 5,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 5,
    customPaging: i => (
      <button
        style={{
          width: "9px",
          height: "9px",
          marginRight: "16px",
          borderRadius: "100%",
          textIndent: "-9999px"
        }}
      >
        {i + 1}
      </button>
    ),
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
          dots: false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 1,
          dots: false
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false
        }
      }
    ]
  };

  // Get handlers from context
  const { handleCard: contextHandleCard, handleProgramated, updateVehicleTable } = useOperation();

  const handleCard = async (id, type, name, index) => {
    await contextHandleCard(id, type, name, index);
  };

  const handleStatus = async () => {
    await updateVehicleTable();
  };


  return (
    <Grid
      container
      className={classes.contentSlide}
      style={{ display: "block" }}
    >
      <Grid item md={12} className={classes.titleOptions}>
        {operationData.activeIndex !== "" ? (
          <h5>Mostrando información de: {operationData.nameVehicle} </h5>
        ) : (
          <h5>Elige un vehículo. Mostrando todos: </h5>
        )}
        <button onClick={() => setOpen(!open)}>
          {!open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </button>
      </Grid>
      <Grid item sm={12} md={12}>
        <div
          className={
            classes.transitionSlide +
            " " +
            (!open ? classes.openSlide : " ")
          }
        >
          <Slider {...settings}>
            {operationData.arrayVehicle.map((item, index) => {
              return (
                <CardSlide
                  key={index}
                  index={index}
                  activeIndex={operationData.activeIndex}
                  statusTable={operationData.statusTable}
                  item={item}
                  handleCard={handleCard}
                />
              );
            })}
          </Slider>
          <div className={classes.buttonGroup}>
            <button
              className={classes.viewGeneral}
              onClick={handleStatus}
            >
              {operationData.statusTable === "general" ? <strong>Ver todos</strong> :  "Ver todos" }
            </button>
            <button
              className={classes.programated}
              onClick={handleProgramated}
            >
              {operationData.statusTable === "programated" ? <strong>Ver puntos no programados</strong> :  "Ver puntos no programados" }
            </button>
          </div>
        </div>
      </Grid>
    </Grid>
  );
}

export default Slide;